import React from 'react';
import { Link } from 'react-router-dom';

const TERMS = [
  'Every clinic with an active paid AUDINEXA subscription gets one permanent referral code and link. Codes cannot be changed.',
  'A referral code can only be entered at sign-up, before the referred clinic\'s first payment.',
  'Referrer reward: 1 free month when the referred clinic is on the Clinic plan, 2 free months on the Chain plan. Referred clinic reward: 1 free month.',
  'Rewards are locked at qualification, based on the referred clinic\'s plan at that time. Qualification is reviewed and approved by the AUDINEXA team.',
  'Annual (and other prepaid) subscribers: the renewal date moves forward by the months earned. Monthly subscribers qualify after 3 consecutive paid months; earned months are recorded and applied to future billing.',
  'Maximum 12 free months per clinic in any rolling 12-month period. Referrals beyond the cap still count as qualified but earn 0 months.',
  'Every 3 qualified referrals in a calendar year earns a "Smart Marketing free for 3 months" entitlement (activation announced separately).',
  'Not eligible: self-referrals or the same owner entity (matched by GST, RCI registration or phone), Clinic-to-Chain upgrades, clinics returning within 12 months of cancelling, and Enterprise / hospital accounts.',
  'Earned months are forfeited if the referrer\'s subscription lapses for more than 60 days. Rewards may be reversed if a referral is found to be invalid or the referred subscription is refunded.',
];

export default function ReferralTermsPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6" data-testid="referral-terms-page">
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-2xl p-8">
        <h1 className="text-3xl font-bold text-slate-900">AUDINEXA Referral Program — Terms</h1>
        <ol className="mt-6 space-y-3 list-decimal pl-5 text-sm text-slate-700 leading-relaxed">{TERMS.map((t) => <li key={t}>{t}</li>)}</ol>
        <Link to="/refer" className="inline-block mt-8 text-sm text-indigo-600 hover:underline" data-testid="referral-terms-back">← Back to Refer &amp; Earn</Link>
      </div>
    </div>
  );
}
